import { UserRoundCog } from "lucide-react";
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { devLogin, useDevUsers } from "@/lib/dev-auth";

/**
 * "Switch dev user" section for the sidebar user menu. Rendered only when
 * the API runs with AUTH_MODE=dev (local platform development).
 */
export function DevUserMenuItems({
  currentUserId,
}: {
  currentUserId?: string;
}) {
  const users = useDevUsers();
  const others = users?.filter((u) => u.id !== currentUserId) ?? [];
  if (others.length === 0) return null;

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="text-xs font-medium text-muted-foreground">
        Switch dev user
      </DropdownMenuLabel>
      {others.map((user) => (
        <DropdownMenuItem
          key={user.key}
          onClick={() => devLogin(user.key, window.location.pathname)}
        >
          <UserRoundCog className="mr-2 h-3.5 w-3.5" />
          <span className="min-w-0">
            <span className="block truncate">{user.displayName}</span>
            <span className="block truncate text-xs text-muted-foreground">
              {user.summary}
            </span>
          </span>
        </DropdownMenuItem>
      ))}
    </>
  );
}
